import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#818181",
		d: "M15.833 10.833h-5v5H9.167v-5h-5V9.167h5v-5h1.666v5h5v1.666z"
	})
});
export default SvgIconAdd;
